export default [
  { text: 'None', value: 0, hint: 'No sub policy - anyone can use the bid' },
  { text: 'Loose', value: 1, hint: 'At least one player from the awarded team must remain on the team' },
  { text: 'Strict', value: 99, hint: 'Can only be used as a team' }
]
